module.exports = __webpack_public_path__ + "img/bg04.dff7ddf2.jpg";